<div class="view-item">
    <p id="warning">
        <mat-icon>help_outline</mat-icon> 
        Pour ouvrir le .CSV dans Excel : Ouvrir un classeur vierge.
        <br/>Aller dans le menu 'Données' puis 'Obtenir de données', 'A partir d'un fichier', 'A partir d'un fichier texte/csv'
        <br/>Ensuite choisir en haut à gauche 'Origine du fichier' :: <b>65001 Unicode (UTF-8)</b> <br><br>
        <a class="btn btn-color" (click)="prepareCSV()" [href]="csvUrl" download="result.csv">Télécharger</a>
    </p>
</div>
